import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CalendarSearch from "../../../Layout/Master/MasterUtils/Components/CalendarSearch/CalendarComp";
import NoRecordFound from "../NoRecordFound/NoRecordFound";
import { availableFilters, bodyMethods } from "./AppCustomTableUtils";
import { useTranslation } from "react-i18next";

const AppCustomTable = (props) => {
  const rowsPerPageOptions = [5, 10, 20, 50]; 
  const defaultRowsPerPage = 10;
  const [filter, setFilter] = useState(false); 
  const { t } = useTranslation("master");

  const modifiedDateTimeNameRowFilterTemplate = (options = {}) => {
    return <CalendarSearch options={options} setFilter={setFilter} />;
  };

  const {
    columns,
    data,
    isApiLoading,
    selectedItems,
    onSelectionChange,
    filterMethodsConfig,
    dataKey,
    className,
    page = 0,
    pageSize = defaultRowsPerPage,
    onPageChange,
    totalCount
  } = props;
  const [filters, setFilters] = useState({});
  useEffect(() => {
    const initialFilters = {};
    columns.forEach(col => {
      initialFilters[col.field] = { value: null, matchMode: "contains" };
    });
    setFilters(initialFilters);
  }, [columns]);
   const handlePageChange = (e) => {
    onPageChange(e.page + 1, e.rows);
  };
  if (isApiLoading) {
    return <div>Loading...</div>;
  }

  function getSelectionMode(field) {
    return field === "select" ? "multiple" : null;
  }

  if (!data || totalCount === undefined || totalCount === null) {
    return <NoRecordFound />;
  }

  /**Creating Filter Methods */
  let filterMethods = {};
  Object.keys(filterMethodsConfig).forEach((key) => {
    if (availableFilters.hasOwnProperty(filterMethodsConfig[key])) {
      filterMethods[key] = availableFilters[filterMethodsConfig[key]](
        props.data,
        key
      );
    }
  });

  const handleFilterOnEnter = (e, primeReactFilterEvent) => {
  if (e.key === "Enter" && e.target.value.trim().length >= 2) {
    handleFilter(primeReactFilterEvent);
  }
};
  const handleFilter = (e) => {
    const primeFilters = e.filters;
    const formattedFilters = {};
    setFilters(primeFilters);
    Object.keys(primeFilters).forEach((key) => {
      const value = primeFilters[key]?.value;
      if (value !== undefined && value !== null && value !== "") {
        formattedFilters[key] = value;
      }
    });
    props.onFilterChange && props.onFilterChange(formattedFilters);
  };

  return (
    <>
      <DataTable
        lazy
        className={className}
        resizableColumns
        selectionMode={"checkbox"}
        value={data}
        size="small"
        filterDisplay="row"
        loading={isApiLoading}
        dataKey={dataKey}
        emptyMessage="No data found."
        selection={selectedItems}
        onSelectionChange={onSelectionChange}
        scrollable
        scrollHeight="347px"
        style={{ width: "100%", maxWidth: "1400px" }}
        paginator
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        rows={pageSize}
        first={(page - 1) * pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        onPage={handlePageChange}
        totalRecords={totalCount}
        paginatorLeft={<div style={{ textAlign: "left", width: "100%" }} />}
        paginatorRight={null}
        filters={filters}
        onFilter={(e) => {
          const activeElement = document.activeElement;
          activeElement?.addEventListener("keydown", (ev) => handleFilterOnEnter(ev, e), { once: true });
        }}
      >
        {columns.map((column) =>
          column.isCalendar ? (
            <Column
              key={column.field}
              selectionMode={getSelectionMode(column.field)}
              header={t(column.header)}
              field={column.field}
              frozen={column.frozen}
              filterPlaceholder={column.filterPlaceholder || "Search"}
              body={bodyMethods[column.field]}
              filterField={[column.filterField]}
              dataType="date"
              showFilterMenu={filter}
              filter
              filterElement={modifiedDateTimeNameRowFilterTemplate}
            />
          ) : (
            <Column
              key={column.field}
              selectionMode={getSelectionMode(column.field)}
              header={t(column.header)}
              field={column.field}
              filter={column.filter}
              showFilterMenu={column.showFilterMenu}
              filterElement={filterMethods[column.field]}
              frozen={column.frozen}
              filterPlaceholder={column.filterPlaceholder || "Search"}
              body={bodyMethods[column.field]}
            />
          )
        )}
      </DataTable>
    </>
  );
};

export default AppCustomTable;
